import { FC, useState } from 'react';
import { createPortal } from 'react-dom';
import BurgerButton from './BurgerButton';
import BurgerMenuContent from './BurgerMenuContent';
import { useNotifications } from '../profileMenu/useNotifications';
import { cn } from 'lib/utils';

const BurgerMenu: FC = () => {
  const [showMenu, setShowMenu] = useState<boolean>(false);
  const toggleOpen = () => setShowMenu(!showMenu);
  const { notifications } = useNotifications();

  return (
    <>
      <div className="block md:hidden relative animate-fade-in mr-[5px]">
        <BurgerButton onClick={toggleOpen} />
        {notifications?.length > 0 && (
          <div
            className={cn(
              'grid absolute -top-[8px] -right-[8px] rounded-full bg-bionic-error min-w-[18px] min-h-[18px] p-[1px] justify-center items-center font-semiBold text-[10px]',
              notifications.length < 10 ? 'aspect-square' : ''
            )}
          >
            {notifications.length}
          </div>
        )}
      </div>
      {showMenu &&
        createPortal(
          <BurgerMenuContent
            notifications={notifications}
            toggleOpen={toggleOpen}
          />,
          document.body
        )}
    </>
  );
};

export default BurgerMenu;
